module.exports = __webpack_public_path__ + "static/media/image-card-8.55d74081.png";